import type { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';
import type { TagPresetType } from '@n3/css-base';

import { Tag, tagPresets } from '../Tag';

type PageType = 'list' | 'form' | 'parent';

type StyledWrapperProps = {
  $pageType: PageType;
};

export const StyledWrapper = styled.div<StyledWrapperProps>(
  ({
    $pageType,

    theme: { pageTitle },
  }) => ({
    display: 'flex',
    gap: pageTitle.ACTIONS_GAP,
    marginBottom:
      $pageType === 'form'
        ? pageTitle.FORM_TYPE_MARGIN_BOTTOM
        : pageTitle.DEFAULT_TYPE_MARGIN_BOTTOM,
    marginLeft: pageTitle.MARGIN_LEFT,
  }),
);

export const StyledTitle = styled.div(({ theme: { pageTitle } }) => ({
  flex: 1,
  display: 'flex',
  justifyContent: pageTitle.TITLE_JUSTIFY_CONTENT,
  alignItems: pageTitle.TITLE_ALIGN_ITEMS,
  gap: pageTitle.STATUS_GAP,
}));

type StyledTitleTextProps = {
  $pageType: PageType;
};

export const StyledTitleText = styled.div<StyledTitleTextProps>(
  ({
    $pageType,

    theme: { colors, fonts, pageTitle },
  }) => ({
    ...($pageType === 'parent'
      ? fonts[pageTitle.PARENT_TYPE_TITLE_FONT]
      : fonts[pageTitle.DEFAULT_TYPE_TITLE_FONT]),
    color: colors.TEXT_PRIMARY,
  }),
);

export const StyledStatus = styled.div(({ theme: { pageTitle } }) => ({
  marginTop: pageTitle.STATUS_MARGIN_TOP,
}));

export const StyledActions = styled.div({});

export type PageTitleProps = {
  /**
   * Тип страницы
   */
  pageType?: PageType;
  /**
   * Блок действий (кнопки и т.п.)
   */
  actionsBlock?: ReactNode;
  /**
   * Статус
   */
  status?: ReactNode;
  /**
   * Цвет тэга статуса
   */
  statusColor?: TagPresetType;
  /**
   * Заголовок страницы
   */
  children?: ReactNode;
};

export function PageTitle({
  children = undefined,
  pageType = 'list',
  actionsBlock = undefined,
  status = undefined,
  statusColor = tagPresets.GRAY,
}: PageTitleProps): ReactElement {
  return (
    <StyledWrapper $pageType={pageType}>
      <StyledTitle>
        <StyledTitleText $pageType={pageType}>{children}</StyledTitleText>

        {status && (
          <StyledStatus>
            <Tag preset={statusColor}>{status}</Tag>
          </StyledStatus>
        )}
      </StyledTitle>

      {actionsBlock && <StyledActions>{actionsBlock}</StyledActions>}
    </StyledWrapper>
  );
}
